/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PlayerDetailsResponse
 */
export interface PlayerDetailsResponse {
    /**
     * 
     * @type {string}
     * @memberof PlayerDetailsResponse
     */
    errorMessage?: string;
    /**
     * Last four digits of the player's SSN.
     * @type {string}
     * @memberof PlayerDetailsResponse
     */
    ssn4?: string;
    /**
     * Date of birth (ISO YYYY-MM-DD).
     * @type {string}
     * @memberof PlayerDetailsResponse
     */
    dob?: string;
    /**
     * 
     * @type {string}
     * @memberof PlayerDetailsResponse
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof PlayerDetailsResponse
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof PlayerDetailsResponse
     */
    postalCode?: string;
    /**
     * 
     * @type {string}
     * @memberof PlayerDetailsResponse
     */
    region?: string;
    /**
     * 
     * @type {string}
     * @memberof PlayerDetailsResponse
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof PlayerDetailsResponse
     */
    addressLine2?: string;
    /**
     * 
     * @type {string}
     * @memberof PlayerDetailsResponse
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof PlayerDetailsResponse
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof PlayerDetailsResponse
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof PlayerDetailsResponse
     */
    name?: string;
}

/**
 * Check if a given object implements the PlayerDetailsResponse interface.
 */
export function instanceOfPlayerDetailsResponse(value: object): value is PlayerDetailsResponse {
    return true;
}

export function PlayerDetailsResponseFromJSON(json: any): PlayerDetailsResponse {
    return PlayerDetailsResponseFromJSONTyped(json, false);
}

export function PlayerDetailsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlayerDetailsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'ssn4': json['ssn4'] == null ? undefined : json['ssn4'],
        'dob': json['dob'] == null ? undefined : json['dob'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'email': json['email'] == null ? undefined : json['email'],
        'postalCode': json['postalCode'] == null ? undefined : json['postalCode'],
        'region': json['region'] == null ? undefined : json['region'],
        'city': json['city'] == null ? undefined : json['city'],
        'addressLine2': json['addressLine2'] == null ? undefined : json['addressLine2'],
        'address': json['address'] == null ? undefined : json['address'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function PlayerDetailsResponseToJSON(value?: PlayerDetailsResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'errorMessage': value['errorMessage'],
        'ssn4': value['ssn4'],
        'dob': value['dob'],
        'phone': value['phone'],
        'email': value['email'],
        'postalCode': value['postalCode'],
        'region': value['region'],
        'city': value['city'],
        'addressLine2': value['addressLine2'],
        'address': value['address'],
        'lastName': value['lastName'],
        'firstName': value['firstName'],
        'name': value['name'],
    };
}

